import React, { useMemo, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Layout,
  Checkbox,
  Row,
  Col,
  Form,
  Radio,
  Select,
  Collapse,
  Button,
  Spin,
  Switch,
  Breadcrumb
} from "antd";
import { useTranslation } from "react-i18next";
import {
  RightSquareOutlined,
  EditOutlined,
  LeftSquareOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
// import StepSider from "./StepSider";
import { getRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content, Sider } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const { Panel } = Collapse;
const SuperUserRoleList = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [arrow, setArrow] = useState("Show");
  const [loading, setLoading] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null); // State for selected group ID
  const [groupResponse, setGroupResponse] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);


  const manageUserSteps = async () => {
    setLoading(true);
    try {
      let apiResponse = await getRequest(
        `create-group-permissions/get-group-permission-by-user/`
      );
      console.log("apiResponse 10 ", apiResponse);

      if (apiResponse.status === 200) {
        setGroupResponse(apiResponse.data.response.user_group_permissions);
      }
      setLoading(false);
    } catch (error) {
      // ErrorNotificationMsg(t("error_in_prapproval_hierarchy"));
      setLoading(true);
    }
  };

  useEffect(() => {
    manageUserSteps();
  }, []);
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);

    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };


  useEffect(() => {
    if (groupResponse.length > 0) {
      const firstGroupName = groupResponse[0].group_name;
      const firstGroupId = groupResponse[0].group_id
      setSelectedGroup(firstGroupName);
      setSelectedGroupId(firstGroupId);
    }
  }, [groupResponse]);

  console.log("groupResponse ", groupResponse);
  const colors = ["#094E8F"];

  const onChange = (key) => {
    console.log(key);
  };

  // const groupedPermissions = groupResponse?.reduce((acc, group) => {
  //   group.permissions.forEach((permission) => {
  //     const modelName = permission.model_name;
  //     if (!acc[modelName]) {
  //       acc[modelName] = [];
  //     }
  //     acc[modelName].push(permission);
  //   });
  //   return acc;
  // }, {});

  // const groupedFamilies = groupResponse.reduce((acc, group) => {
  //   const family = group.group_role_family;
  //   if (!acc[family]) {
  //     acc[family] = new Set();
  //   }
  //   acc[family].add(group.group_name);
  //   return acc;
  // }, {});

  // const groupedFamilies = groupResponse.reduce((acc, group) => {
  //   const family = group.group_role_family;
  //   if (!acc[family]) {
  //     acc[family] = new Set();
  //   }
  //   acc[family].add(group.group_name);
  //   return acc;
  // }, {});

  const groupedFamilies = groupResponse.reduce((acc, group) => {
    const family = group.group_role_family;
    if (!acc[family]) {
      acc[family] = [];
    }
    acc[family].push({ name: group.group_name, id: group.group_id });
    return acc;
  }, {});


  const selectedGroupData = groupResponse.find(
    (group) => group.group_name === selectedGroup
  );
  const selectedGroupPermissions = selectedGroupData?.permissions || [];

  // const groupedPermissions = selectedGroupPermissions.reduce((acc, permission) => {
  //   const modelName = permission.model_name;
  //   if (!acc[modelName]) {
  //     acc[modelName] = [];
  //   }
  //   acc[modelName].push(permission);
  //   return acc;
  // }, {});
  const onGroupNameClick = (groupId, groupName) => {
    setSelectedGroup(groupName)
    setSelectedGroupId(groupId); // Update state with selected group ID
    console.log(`Select `, groupId, "Group Name", groupName);

  };
  const groupedPermissions = selectedGroupPermissions.reduce(
    (acc, permission) => {
      const modelName = permission.model_name;
      if (!acc[modelName]) {
        acc[modelName] = [];
      }
      acc[modelName].push(permission);
      return acc;
    },
    {}
  );
  console.log(selectedGroupId, "selectedGroupId");

  const handleSubmit = () => {
    updateSubscriptionStatus();
    navigate("/manage-user-step")
  }

  function formatModelName(modelName) {
    return modelName
      .split('_') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');                   
  }

  return (
    <>
      <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                <h3>Manage User Group</h3>
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
    
                  <Breadcrumb.Item>Manage User Group</Breadcrumb.Item>
                </Breadcrumb>
                </div>
          
              
            </div>
          </div>
            <Content className="stepscontentwrap">
            
              <div className="stepsContent">
                <div className="formwrapper">
                  <Spin spinning={loading}>
                  <div className="custometabswrap">
                    <div className="usersiderwrp">
                      <Sider
                        className="tabscolumn"
                        width={292}
                        breakpoint="lg"
                        collapsedWidth="0"
                        trigger={null}
                        collapsible
                        collapsed={collapsed}
                      >
                        {Object.entries(groupedFamilies).map(
                          ([family, groups], index) => {
                            return (
                              <div key={index}>
                                <h3>{family === "null" ? "" : family}</h3>
                                <ul>
                                  {groups.map((group, idx) => (
                                    <li
                                      className={group.name === selectedGroup ? "active" : ""}
                                      key={group.id}
                                      // onClick={() => setSelectedGroup(group.name)}
                                      onClick={() => onGroupNameClick(group.id, group.name)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {group.name}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )
                          }
                        )}
                      </Sider>
                      <div className="siderarrowcol">
                        {React.createElement(
                          collapsed ? RightSquareOutlined : LeftSquareOutlined,
                          {
                            className: "trigger",
                            onClick: () => setCollapsed(!collapsed),
                          }
                        )}
                      </div>
                    </div>
                    <Content className="tabscontent">
                      <div className="tobtnwrap">

                        {selectedGroupId !== null ?
                          <Button
                            icon={<EditOutlined />}

                            onClick={() =>
                              navigate("/superuser-role/edit/" + btoa(selectedGroupId))
                            }
                          >
                            Edit
                          </Button> : ""
                        }
                        <Button
                          icon={<PlusCircleOutlined />}
                          onClick={() => navigate("/superuser-role/add")}
                        >
                          Add New User Group
                        </Button>
                      </div>
                      {/* <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                        {Object.entries(groupedPermissions).map(
                          ([modelName, permissions], index) => (
                            <Panel header={modelName} key={index}>
                              {permissions.map((permission, index) => (
                                <div
                                  className="permissionlist TextFeild"
                                  key={index}
                                >
                                  {permission.name}
                                  <Form.Item className="radioitem">
                                    <Radio.Group
                                      name="radiogroup"
                                      defaultValue={permission.is_checked ? 1 : 2}
                                    >
                                      <Radio value={1}>Yes</Radio>
                                      <Radio value={2}>No</Radio>
                                    </Radio.Group>
                                  </Form.Item>
                                </div>
                              ))}
                            </Panel>
                          )
                        )}
                      </Collapse> */}
                      {selectedGroup && (
                        <Collapse defaultActiveKey={["0"]}>
                          {Object.entries(groupedPermissions).map(
                            ([modelName, permissions], index) => (
                              <Panel header={formatModelName(modelName)} key={index}>
                                {permissions.map((permission, idx) => (
                                  <div className="permissionlist TextFeild" key={idx}>
                                      <Form.Item className="radioitem">
                                      {/* <Radio.Group
                                      name="radiogroup"
                                      // defaultValue={permission.is_checked ? 1 : 2}
                                      value={permission.is_checked === true ? 1 : 2 }
                                      disabled
                                    >
                                      <Radio value={1}>Yes</Radio>
                                      <Radio value={2}>No</Radio>
                                    </Radio.Group> */}
                                      <Switch
                                        checked={permission.is_checked}
                                        disabled
                                      />
                                    </Form.Item>
                                    {permission.name}
                                  
                                  </div>
                                ))}
                              </Panel>
                            )
                          )}
                        </Collapse>
                      )}
                    </Content>
                  </div>
                  </Spin>
                </div>
              </div>
              <div className="stepsFooter">
                {/* <Button
                  cursor="pointer"
                  type="secondary"
                  className="primary"
                  onClick={() => navigate("/site-location-step")}
                >
                  Previous
                </Button>
                <Button
                  cursor="pointer"
                  type="primary"
                  className="primary"
                  onClick={handleSubmit}
                >
                  Save & Next
                </Button> */}
              </div>
            </Content>
     
    </>
  );
};

export default SuperUserRoleList;
